export default {
    screen: "dashboard",
    errorToShow: undefined,
    termsLoading: false,
    rehydrateDone: false,
    terms: undefined
}



// WEBPACK FOOTER //
// ./src/redux/reducers/app/init.js